<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_sales'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select
                      class="form-select form-select-sm mx-1"
                      v-model="perPage"
                      size="sm"
                      :options="Options"
                    ></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                class="text-center"
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
                <template #table-busy>
                  <div class="text-primary my-2">
                    <b-spinner
                      class="align-middle"
                      type="grow"
                      small
                    ></b-spinner>
                    <strong>No Data Found</strong>
                  </div></template
                >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(supplier)="data">
                  {{ data.item.supplier ? data.item.supplier.name : "-" }}
                </template>
                <template #cell(customer)="data">
                  {{ data.item.customer.name || "-" }}
                </template>
                <template #cell(date_added)="data">
                  {{ data.item.date_added }}
                </template>

                <template #cell(balance)="data">
                  <div v-if="data.item.price_paid < data.item.amount">
                    {{ data.item.amount - data.item.price_paid }}<br />
                    <button
                      class="btn btn-sm btn-primary"
                      @click.prevent="
                        getTransaction(
                          data.item.purchase_id,
                          data.item.amount - data.item.price_paid
                        )
                      "
                    >
                      <span v-if="loader2"
                        ><b-spinner small class="mr-1" label="Small Spinner"
                      /></span>
                      <span v-else
                        ><i class="mdi mdi-cash"></i> <b>Pay</b></span
                      >
                    </button>
                  </div>
                  <div class="text-success" v-else>
                    <i class="fas fa-check"></i> Cleared
                  </div>
                </template>
                <template #cell(cost)="data">
                  {{ commas(data.item.cost) }}
                </template>
                <template #cell(added_by)="data">
                  {{ data.item.added_by }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn">
                    <b-button
                      @click="getDetails(data.item.purchase_id, data.item.price_paid)"
                      type="button"
                      class="btn-sm btn"
                      :class="{
                        'disabled btn-secondary': !userData.permissions[
                          'view_sale_details'
                        ],
                      }"
                      variant="info"
                      v-b-modal.edit
                    >
                      <span v-if="loader"
                        ><b-spinner small class="mr-1" label="Small Spinner"
                      /></span>
                      <span v-else
                        ><i class="mdi mdi-eye"></i> view</span
                      ></b-button
                    >
                  </div>
                </template>
              </b-table>
              <div class="row mt-3">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="total-payments">
                <strong>Cost of Goods:</strong> {{ commas(TotalBuyingPrice ) }}

              
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="view-visit"
      centered
      :title="`Details for Trans: ${purchase_id}`"

      title-class="font-14"
      hide-footer
      size="lg"
    >
      <table class="table">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Product</th>
            <th scope="col">Unit</th>
            <th scope="col">Quantity</th>
            <th scope="col">Price</th>
            <th scope="col">Batch</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(detail, index) in details" :key="index">
            <th scope="row">{{ index + 1 }}</th>
            <td>
              <div>
                <div>{{ detail.product.name }}</div>
                <small class="text-success">{{ detail.category.name }}</small>
              </div>
            </td>
            <td>
              {{ detail.unit.unit_name }}
            </td>
            <td>{{ detail.quantity }}</td>
            <td>{{ detail.price }}</td>
            <td>
              <div>{{ detail.batch || "-" }}</div>
              <small class="text-success">{{ detail.expiry_date }}</small>
            </td>
          </tr>
        </tbody>
      </table>
      
      <div class="form-group d-flex justify-content-end">
        <b-button
          type="button"
          class="btn w-30"
          variant="secondary"
          @click="$bvModal.hide('view-visit')"
          >Close</b-button
        >
      </div>
    </b-modal>

    <b-modal
      id="view-pay"
      centered
      title="Balance Payment"
      title-class="font-14"
      hide-footer
    >
      <form @submit.prevent="editPayment">
        <input v-model="purchase_id" type="hidden" />
        <div class="form-group mb-2">
          <label>Balance to Pay</label>
          <input v-model="balance" type="number" class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Payment Method</label>
          <multiselect
            v-model="payment_method"
            :options="paymentoptions"
            label="name"
          ></multiselect>
        </div>
        <div class="form-group mb-2">
          <label>Pay Date</label>
          <input v-model="paydate" type="date" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button
            type="button"
            class="btn w-30"
            variant="secondary"
            @click="$bvModal.hide('view-pay')"
            >Close</b-button
          >
          <b-button type="submit" class="btn ms-1 w-30" variant="primary">
            <span v-if="loader3"
              ><b-spinner small class="mr-1" label="Small Spinner"
            /></span>
            <span v-else><i class="fas fa-check-circle"></i> Submit</span>
          </b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  purchaseComputed,
  purchaseMethods,
  paymentoptionComputed,
  paymentoptionMethods,
} from "@/state/helpers";

export default {
  page: {
    title: "View Stock Purchases",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "View Stock Purchases",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "View Stock Purchases", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true, tdClass: "align-middle" },
        { key: "id", label: "ID", visible: false, tdClass: "align-middle" },
        {
          key: "purchase_id",
          label: "Purchase ID",
          visible: true,
          tdClass: "align-middle",
        },
        {
          key: "amount",
          label: "Total Buy Price",
          visible: true,
          tdClass: "align-middle",
        },
        {
          key: "balance",
          label: "Balance",
          visible: true,
          tdClass: "align-middle",
        },
        {
          key: "supplier",
          label: "Supplier",
          visible: true,
          tdClass: "align-middle",
        },
        {
          key: "created_at",
          label: "Date added",
          visible: true,
          tdClass: "align-middle",
        },
        {
          key: "addedby",
          label: "Added by",
          visible: true,
          tdClass: "align-middle",
        },
        {
          key: "actions",
          label: "Actions",
          visible: true,
          tdClass: "align-middle",
        },
      ],
      salesdetails: [],
      id: "",
      purchase_id: "",
      telephone: "",
      name: "",
      nationality: "",
      gender: "",
      address: "",
      dateofbirth: "",
      total: 0,
      invest: 0,
      cost: 0,
      payment_method: "",
      balance: 0,
      paydate: "",
      customer: "",
      details: "",

      // Loaders
      loader: "", // for viewing sale details
      loader2: "", // for pay balance button
      loader3: "", // for submiting balance
    };
  },
  computed: {
    ...purchaseComputed,
    ...paymentoptionComputed,
    List() {
      return this.purchases.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.purchases.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.purchases.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
    TotalBuyingPrice() {
      return this.purchases.reduce((total, purchase) => total + parseInt(purchase.amount), 0);
  }
  },
  mounted() {
    this.fetchPurchases();
    this.fetchPaymentoptions();
    this.TotalRows = this.purchases.length;
    this.isBusy = false;
    this.payment_method = this.paymentoptions.find(
      (option) => option.set_default == 1
    );
  },
  methods: {
    ...paymentoptionMethods,

    defaultDate() {
      let currentDate = new Date();

      let year = currentDate.getFullYear();
      let month = currentDate.getMonth() + 1; // Months are zero-based, so add 1
      let day = currentDate.getDate();


      let formattedDate = `${year}-${month
        .toString()
        .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;
      this.paydate = formattedDate;
    },

    async editPayment() {
      this.loader3 = true;
      let newForm = new FormData();
      newForm.append("purchase_id", this.purchase_id);
      newForm.append("balance", this.balance);
      newForm.append("paymentoption", this.payment_method.id);
      newForm.append("pay_date", this.paydate);
      let url = "/clear_balance";
      const response = await axios.post(url, newForm);
      if (response) {
        this.$bvModal.hide("view-pay");
        this.$toast.success("Updated Purchase Payemnt!");
        this.fetchPurchases();
      }
      this.loader3 = false;
    },

    async getTransaction(purchase_id, balance) {
      this.loader2 = true;
      this.purchase_id = purchase_id;
      this.defaultDate();
      this.balance = balance;
      this.$bvModal.show("view-pay");
      this.loader2 = false;
    },

    async getDetails(purchase_id, price_paid) {
      this.purchase_id = purchase_id;
      let url = `purchase_details/${purchase_id}`;
      this.price_paid = price_paid;
      const response = await axios.get(url);
      if (response.status == 200) {
        this.details = response.data.details;

        this.$bvModal.show("view-visit");
      }
    },

    commas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    ...purchaseMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
